// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__c9O2-","buttons":"PendingPaymentAlert_buttons__3vm6p"};